/**
 * Format a date for sending request to server
 */
export default function formatDateForAPI(
    date?: Date,
    utc = true,
): string | undefined {
    if (!date) {
        return undefined;
    }
    // if (typeof date.getMonth !== 'function') {
    //     date = new Date(date);
    // }
    const [year, month, day] = utc
        ? [date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()]
        : [date.getFullYear(), date.getMonth(), date.getDate()];

    return (
        year + '-' + ('0' + (1 + month)).slice(-2) + '-' + ('0' + day).slice(-2)
    );
}

export function getFormattedCurrentDate(): string {
    const date = new Date();
    return `${date.getUTCFullYear()}-${prependZero(date.getUTCMonth() + 1)}`;
}

// When `num` is less than 10, then prepend zero. Else, return the number.
export function prependZero(num: number): string {
    return `0${num}`.slice(-2);
}
